import { render } from "./CollectSVITable.vue?vue&type=template&id=5f25c357"
import script from "./CollectSVITable.vue?vue&type=script&lang=js"
export * from "./CollectSVITable.vue?vue&type=script&lang=js"

import "./CollectSVITable.vue?vue&type=style&index=0&id=5f25c357&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__